import type { MenuQueryParams } from './menuQueryContext'

type PreviewContext = {
  menu_id: string
  auth_user_id: string
  expiry: string
  signature: string
}

const PREVIEW_PARAM_KEYS = {
  menuId: 'preview[menu_id]',
  authUserId: 'preview[auth_user_id]',
  expiry: 'preview[expiry]',
  signature: 'preview[signature]',
} as const

const isSingleNonEmptyString = (value: unknown): value is string =>
  typeof value === 'string' && value.trim().length > 0

const isNumericString = (value: string) => /^\d+$/.test(value)

export const getMenuExperiencePreview = (query: MenuQueryParams): string | undefined => {
  const menuId = query[PREVIEW_PARAM_KEYS.menuId]
  const authUserId = query[PREVIEW_PARAM_KEYS.authUserId]
  const expiry = query[PREVIEW_PARAM_KEYS.expiry]
  const signature = query[PREVIEW_PARAM_KEYS.signature]

  if (
    !isSingleNonEmptyString(menuId) ||
    !isSingleNonEmptyString(authUserId) ||
    !isSingleNonEmptyString(expiry) ||
    !isSingleNonEmptyString(signature) ||
    !isNumericString(expiry)
  ) {
    return undefined
  }

  const previewContext: PreviewContext = {
    menu_id: menuId,
    auth_user_id: authUserId,
    expiry,
    signature,
  }

  return JSON.stringify(previewContext)
}
